export default __webpack_public_path__ + "static/media/survey_re_evaluation.9c3c1f13.png";